__turbopack_context__.v({
  "dialogContent": "ConnectAppDialog-module__wibQrG__dialogContent",
  "form": "ConnectAppDialog-module__wibQrG__form",
  "tip": "ConnectAppDialog-module__wibQrG__tip",
});
